<template>
  <div
    class="ui-help"
    :class="{ 'ui-help_error': isError }"
  >
    <slot>
      <div v-html="text" />
    </slot>
  </div>
</template>

<script>
export default {
  name: 'UiHelp',

  props: {
    text: {
      type: String,
      default() {
        return '';
      },
    },
    isError: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },

  computed: {},
};
</script>

<style lang="scss">
.ui-help {
  width: 100%;
  text-align: right;
  margin-top: 4px;
  margin-bottom: 0;

  color: var(--text-body);
  font-size: 12px;
  line-height: 14px;
  font-style: italic;
  &_error {
    color: var(--text-negative);
  }
}
</style>
